import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { InjectionToken, PLATFORM_ID, NgModule, Inject } from '@angular/core';

function clarityScript(projectId) {
    return `(function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window, document, "clarity", "script", "${projectId}");`;
}
const NGX_CLARITY_CONFIG_TOKEN = new InjectionToken('ngx-clarity.config');
class NgxClarityModule {
    constructor(platformId, d, { enabled, projectId }) {
        if (isPlatformBrowser(platformId) && enabled) {
            const s = d.createElement('script');
            s.type = 'text/javascript';
            s.innerHTML = clarityScript(projectId);
            d.head.appendChild(s);
        }
    }
    static forRoot(config) {
        return {
            ngModule: NgxClarityModule,
            providers: [{ provide: NGX_CLARITY_CONFIG_TOKEN, useValue: config }],
        };
    }
}
NgxClarityModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: NgxClarityModule, deps: [{ token: PLATFORM_ID }, { token: DOCUMENT }, { token: NGX_CLARITY_CONFIG_TOKEN }], target: i0.ɵɵFactoryTarget.NgModule });
NgxClarityModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: NgxClarityModule });
NgxClarityModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: NgxClarityModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: NgxClarityModule, decorators: [{
            type: NgModule,
            args: [{}]
        }], ctorParameters: function () {
        return [{ type: Object, decorators: [{
                        type: Inject,
                        args: [PLATFORM_ID]
                    }] }, { type: Document, decorators: [{
                        type: Inject,
                        args: [DOCUMENT]
                    }] }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [NGX_CLARITY_CONFIG_TOKEN]
                    }] }];
    } });

/**
 * Generated bundle index. Do not edit.
 */

export { NgxClarityModule };
